module.exports = __webpack_public_path__ + "img/charlies.330e1803.png";